import {
  NotificationPayload,
  SAMPLE_NOTIFICATION_PAYLOAD,
} from "@/utils/types/notification";

export const validateNotificationPayload = (
  payload: NotificationPayload
): boolean => {
  const requiredFields = [
    "name",
    "channel",
    "send_alert_on",
    "schema_name",
    "message",
    "notification_recipients",
  ];

  for (const field of requiredFields) {
    if (!(field in payload)) {
      console.error(`Missing required field: ${field}`);
      return false;
    }
  }

  if (!Array.isArray(payload.notification_recipients)) {
    return false;
  }

  for (const recipient of payload.notification_recipients) {
    if (!recipient.receiver_by_document_field && !recipient.receiver_by_role) {
      return false;
    }
  }

  return true;
};

export const testSampleNotification = (): boolean => {
  const isValid = validateNotificationPayload(SAMPLE_NOTIFICATION_PAYLOAD);
  return isValid;
};

export const createNotificationPayload = (values: any): NotificationPayload => {
  const channelMap: { [key: string]: number } = {
    email: 1,
    sms: 2,
    system: 3,
    whatsapp: 4,
  };

  const alertMap: { [key: string]: number } = {
    new: 1,
    save: 2,
    days_after: 3,
    days_before: 4,
    value_change: 5,
  };

  return {
    name: values.name,
    channel: channelMap[values.channel] ?? 1,
    subject: values.subject ?? "",
    send_alert_on: alertMap[values.send_alert_on] ?? 1,
    schema_name: values.schema_name,
    sender_email: values.sender_email ?? "",
    condition: values.condition ?? "",
    message: values.message,
    attach_print: Boolean(values.attach_print),
    print_format: values.print_format ?? "",
    reference_field: values.reference_field ?? null,
    days_before_or_after: values.days_before_or_after
      ? Number(values.days_before_or_after)
      : null,
    notification_recipients: values.notification_recipients
      ? values.notification_recipients
          .filter(
            (recipient: any) =>
              recipient.receiver_by_document_field ?? recipient.receiver_by_role
          )
          .map((recipient: any) => ({
            receiver_by_document_field:
              recipient.receiver_by_document_field ?? "",
            receiver_by_role: recipient.receiver_by_role ?? null,
            condition: recipient.condition ?? "",
          }))
      : [],
  };
};
